import axios from "@/helpers/axios";

export default {
  namespaced: true,
  state: {
    sprkrBoxes: {
      loading: false,
      data: {}
    },
    rooms: {
      loading: false,
      data: {}
    },
    box: {
      loading: false,
      data: {},
      hides: {}
    },
    myClassrooms: {
      loading: false,
      data: {}
    },
    myBoxes: {
      loading: false,
      data: {}
    },
    classroom: {
      loading: false,
      data: {}
    },
    students: {
      loading: false,
      data: []
    },
    myInvitations: {
      loading: false,
      data: []
    },
    queryWords: {
      loading: false,
      data: []
    },
    issueTypes: [],
    wordTypes: [],
    favBox: []
  },
  mutations: {
    SET_FAV_BOX(state, data) {
      state.favBox = data;
    },
    SET_QUERY_WORDS(state, data) {
      state.queryWords.data = data;
    },
    SET_SPRKR_BOXES(state, data) {
      state.sprkrBoxes.data = data;
    },
    SET_ROOMS(state, data) {
      state.rooms.data = data;
    },
    SET_BOX(state, data) {
      state.box.data = data;
      if (data.progress && data.progress.seen_cards) {
        state.box.hides = data.progress.seen_cards.reduce((accu, item) => {
          if (item.hide_card) {
            accu[item.card] = true;
          }
          return accu;
        }, {});
      }
    },
    SET_MY_BOXES(state, data) {
      state.myBoxes.data = data;
    },
    SET_CLASSROOM(state, data) {
      state.classroom.data = data;
    },
    SET_CLASSROOM_STUDENTS(state, data) {
      state.students.data = data;
    },
    SET_MY_CLASSROOMS(state, data) {
      state.myClassrooms.data = data;
    },
    SET_LOADING_STATUS(state, { entity, status, data = {} }) {
      if (status) {
        state[entity].data = data;
      }
      state[entity].loading = status;
    },
    SET_ISSUE_TYPES(state, data) {
      state.issueTypes = data;
    },
    SET_WORD_TYPES(state, data) {
      state.wordTypes = data;
    },
    SET_MY_INVITATIONS(state, data) {
      state.myInvitations = { data };
    }
  },
  getters: {
    cards(state) {
      const { box } = state;
      if (box && box.data && box.data.cards) {
        const { hides, data } = box;
        if (Object.keys(hides).length == 0) {
          return data.cards;
        }
        return data.cards.filter(item => !hides[item.id]);
      }
      return [];
    },
    hasBoxOwnerRights(state, _getters, rootState) {
      // either it's mine
      if (
        state.box &&
        state.box.data &&
        rootState.account &&
        rootState.account.loggedIn &&
        state.box.data.user == rootState.account.user.id
      ) {
        return true;
      }
      // or I'm admin of box class
      if (
        state.box &&
        state.box.data &&
        (state.box.data.box_type == "CLASS_MEMBER" ||
          state.box.data.box_type == "CLASS")
      ) {
        return state.box.data.admins.includes(rootState.account.user.id);
      }
      return false;
    },
    canEditBox(state, _getters, rootState) {
      // classroom boxes
      if (
        state.box &&
        state.box.data &&
        (state.box.data.box_type == "CLASS_MEMBER" ||
          state.box.data.box_type == "CLASS") &&
        rootState.account &&
        rootState.account.loggedIn &&
        state.box.data.members.includes(rootState.account.user.id)
      ) {
        return true;
      }
      // personal boxes
      if (
        state.box &&
        state.box.data &&
        rootState.account &&
        rootState.account.loggedIn &&
        state.box.data.user == rootState.account.user.id
      ) {
        return true;
      }
      return false;
    },
    getUsername: () => (userId, userList) => {
      if (!userId) {
        return null;
      }
      let user = null;
      if (userList) {
        user = userList.filter(u => {
          return u.id == userId;
        });
      } else {
        return userId;
      }
      if (user && user.length > 0) {
        user = user[0];
        let result = user.name ? user.name : "";
        if (!result) {
          result = user.username ? "'" + user.username + "'" : "";
        }
        result += " [" + user.id + "]";
        return result;
      }
      return userId;
    }
  },
  actions: {
    async getQueryWords({ commit }, { word }) {
      const entity = "queryWords";
      try {
        commit("SET_LOADING_STATUS", { entity, status: true });
        const { data } = await axios.get(`/words/query/?word=${word}`);
        commit("SET_QUERY_WORDS", data.results);
      } catch (err) {
        console.log(err);
      }
      commit("SET_LOADING_STATUS", { entity, status: false });
    },
    async getWordTypes({ commit }) {
      try {
        const { data } = await axios.get(`/word-type/`);
        commit("SET_WORD_TYPES", data.results);
      } catch (err) {
        console.log(err);
      }
    },
    async submitIssue(_, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/create-feedback/`, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async getIssueTypes({ commit }) {
      try {
        const { data } = await axios.get(`/issue-type-list/`);
        commit("SET_ISSUE_TYPES", data.results);
      } catch {
        //
      }
    },
    async BoxStateUpdate(_, { cardId, boxId }) {
      const url = `/stats/box-state/`;
      try {
        await axios.post(url, { card: cardId, box: boxId });
      } catch (err) {
        //
      }
    },
    async updateSeenStat(_, { id, postData }) {
      const url = `/seen-stat/${id}/`;
      try {
        await axios.post(url, postData);
      } catch (err) {
        //
      }
    },
    async toggleHideCard({ commit }, { cardId, boxId }) {
      const url = `/stats/toggle-hide-card/`;
      try {
        const { data } = await axios.post(url, { box: boxId, card: cardId });
        commit("SET_BOX", data);
      } catch (err) {
        //
      }
    },
    async HideCard({ commit, dispatch }, { cardId, nextCardId, boxId }) {
      // nextCardId to simulate a swipe to the right and make that the last card
      const url = `/stats/hide-card/`;
      try {
        const { data } = await axios.post(url, { card: cardId, box: boxId });
        commit("SET_BOX", data);
        if (nextCardId) {
          dispatch("BoxStateUpdate", nextCardId, boxId);
        }
      } catch (err) {
        //
      }
    },
    addToFavBox({ commit }, id) {
      const url = `/cards/${id}/add-fav/`;
      return new Promise((resolve, reject) => {
        axios
          .post(url)
          .then(({ data }) => {
            commit("SET_FAV_BOX", data.cards_id);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async getFavBox({ commit }) {
      try {
        const { data } = await axios.get("/boxes/get-my-fav-box/");
        commit("SET_FAV_BOX", data.cards_id);
      } catch (err) {
        //
      }
    },
    getClassroom({ commit }, id) {
      const entity = `classroom`;
      commit("SET_LOADING_STATUS", { entity, status: true });
      return new Promise((resolve, reject) => {
        axios
          .get(`/classrooms/${id}/`)
          .then(({ data }) => {
            commit("SET_CLASSROOM", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING_STATUS", { entity, status: false });
          });
      });
    },
    getStudentsActivity({ commit }, room_id) {
      const entity = `students`;
      commit("SET_LOADING_STATUS", { entity, status: true, data: [] });
      return new Promise((resolve, reject) => {
        axios
          .get(`/classrooms/${room_id}/students/`)
          .then(({ data }) => {
            commit("SET_CLASSROOM_STUDENTS", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING_STATUS", { entity, status: false });
          });
      });
    },
    async getMyClassrooms({ commit }) {
      const entity = `myClassrooms`;
      commit("SET_LOADING_STATUS", { entity, status: true });
      try {
        const { data } = await axios.get("/my-classrooms/");
        commit("SET_MY_CLASSROOMS", data);
      } catch (err) {
        // console.log(err);
      }
      commit("SET_LOADING_STATUS", { entity, status: false });
    },
    editBoxDetails({ dispatch }, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/boxes/${id}/edit-box-details/`, formData)
          .then(({ data }) => {
            dispatch("getBoxInformation", id);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    createNewBox({ dispatch }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/boxes/create/`, formData)
          .then(({ data }) => {
            dispatch("getMyBoxes");
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteBox({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/boxes/${id}/delete/`)
          .then(({ data }) => {
            dispatch("getMyBoxes");
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    createNewClassroom({ dispatch }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/classrooms/`, formData)
          .then(({ data }) => {
            dispatch("getMyClassrooms");
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    editClassroom({ dispatch }, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/classrooms/${id}/`, formData)
          .then(({ data }) => {
            dispatch("getMyClassrooms");
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteClassroom({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/classrooms/${id}/`)
          .then(({ data }) => {
            dispatch("getMyClassrooms");
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteCard({ dispatch }, { id, boxId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/cards/${id}/delete/`)
          .then(({ data }) => {
            dispatch("getBoxInformation", boxId);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddWordToBox({ dispatch }, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/boxes/${id}/add-card-to-box/`, formData)
          .then(({ data }) => {
            dispatch("getBoxInformation", id);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async getMyBoxes({ commit }) {
      const entity = `myBoxes`;
      commit("SET_LOADING_STATUS", { entity, status: true });
      try {
        const { data } = await axios.get("/my-boxes/");
        commit("SET_MY_BOXES", data);
      } catch (err) {
        // console.log(err);
      }
      commit("SET_LOADING_STATUS", { entity, status: false });
    },
    async getSprkrBoxes({ commit }) {
      const entity = `sprkrBoxes`;
      commit("SET_LOADING_STATUS", { entity, status: true });
      try {
        const { data } = await axios.get(`/all-sprkr-boxes/`);
        commit("SET_SPRKR_BOXES", data);
      } catch (err) {
        // console.log(err);
      }
      commit("SET_LOADING_STATUS", { entity, status: false });
    },
    async getPublicClasses({ commit }) {
      const entity = `rooms`;
      commit("SET_LOADING_STATUS", { entity, status: true });
      try {
        const { data } = await axios.get(`/classrooms/`);
        commit("SET_ROOMS", data);
      } catch (err) {
        // console.log(err);
      }
      commit("SET_LOADING_STATUS", { entity, status: false });
    },
    boxStateIncrementSeenCount(_, postData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`stats/box-state-seen-increment/`, postData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    toggleShareble({ commit }, { id, postData }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/boxes/toggle-shareable/${id}/`, postData)
          .then(({ data }) => {
            commit("SET_BOX", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getBoxInformation({ commit }, id) {
      const entity = `box`;
      commit("SET_LOADING_STATUS", { entity, status: true });
      return new Promise((resolve, reject) => {
        axios
          .get(`/boxes/${id}/`)
          .then(({ data }) => {
            commit("SET_BOX", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING_STATUS", { entity, status: false });
          });
      });
    },
    getQuizInformation({ commit }, id) {
      const entity = `box`;
      commit("SET_LOADING_STATUS", { entity, status: true });
      return new Promise((resolve, reject) => {
        axios
          .get(`/boxes/quiz/${id}/`)
          .then(({ data }) => {
            commit("SET_BOX", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING_STATUS", { entity, status: false });
          });
      });
    },
    submitQuizResult(_, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/stats/quiz-result/`, formData)
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getMyInvitations({ commit }) {
      const entity = `myInvitations`;
      commit("SET_LOADING_STATUS", { entity, status: true });
      return new Promise((resolve, reject) => {
        axios
          .get(`/my-invitations/`)
          .then(({ data }) => {
            commit("SET_MY_INVITATIONS", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING_STATUS", { entity, status: false });
          });
      });
    },
    deleteInvitation({ dispatch }, classroom) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/classrooms/${classroom}/delete-my-invitation/`)
          .then(({ data }) => {
            resolve(data);
            dispatch("getMyInvitations");
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    acceptInvitation({ dispatch }, classroom) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/classrooms/${classroom}/join/`)
          .then(({ data }) => {
            resolve(data);
            dispatch("getMyInvitations");
            dispatch("getMyClassrooms");
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
